module.exports = __webpack_public_path__ + "static/media/app_badge-google.1409b0ad.svg";